// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font = {
    "0": "M103 -148v1094l118 119h410l118 -119v-1094l-118 -118h-410zM287 -81h277v961h-277v-961z",
    "1": "M104 -81h110v880h-110v81l110 185h185v-1146h112v-185h-407v185z",
    "2": "M104 159l462 379v342h-277v-81h-185v147l118 119h410l119 -119v-496l-462 -378v-153h462v-185h-647v425z",
    "3": "M103 0h184v-81h277v388h-207v184h207v389h-277v-81h-184v147l118 119h410l118 -119v-455l-91 -92l91 -92v-455l-118 -118h-410l-118 118v148z",
    "4": "M36 122v185l464 758h186v-758h110v-185h-110v-203h110v-185h-407v185h111v203h-464zM253 307h247v404z",
    "5": "M105 0h185v-81h277v388h-462v758h647v-185h-462v-389h344l118 -117v-522l-118 -118h-410l-119 118v148z",
    "6": "M103 -148v1094l118 119h410l118 -119v-147h-185v81h-277v-389h344l118 -117v-522l-118 -118h-410zM287 -81h277v388h-277v-388z",
    "7": "M96 799v266h647v-214l-361 -1117h-194l370 1146h-277v-81h-185z",
    "8": "M103 -148v455l91 92l-91 92v455l118 119h410l118 -119v-455l-91 -92l91 -92v-455l-118 -118h-410zM287 -81h277v388h-277v-388zM287 491h277v389h-277v-389z",
    "9": "M103 0h184v-81h277v388h-343l-118 117v522l118 119h410l118 -119v-1094l-118 -118h-410l-118 118v148zM287 491h277v389h-277v-389z",
    "A": "M81 -266l130 1331h407l129 -1331h-188l-33 345h-224l-33 -345h-188zM320 265h188l-60 614h-68z",
    "B": "M105 -266v1331h488l94 -93v-502l-69 -71l69 -69v-503l-94 -93h-488zM292 -80h208v386h-208v-386zM292 493h208v386h-208v-386z",
    "C": "M104 -173v1145l93 93h396l94 -93v-173h-187v80h-210v-959h210v80h187v-173l-94 -93h-396z",
    "D": "M105 -266v1331h488l94 -93v-1145l-94 -93h-488zM292 -80h208v959h-208v-959z",
    "E": "M105 -266v1331h582v-186h-395v-386h208v-187h-208v-386h395v-186h-582z",
    "F": "M105 -266v1331h582v-186h-395v-386h208v-187h-208v-572h-187z",
    "G": "M104 -173v1145l93 93h396l94 -93v-173h-187v80h-210v-959h210v386h-105v187h292v-666l-94 -93h-396z",
    "H": "M105 -266v1331h187v-572h210v572h186v-1331h-186v572h-210v-572h-187z",
    "I": "M105 -266v1331h187v-1331h-187z",
    "J": "M57 153h187v-233h210v1145h186v-1238l-94 -93h-396l-93 93v326z",
    "K": "M105 -266v1331h187v-501l208 501h187l-225 -539l225 -792h-187l-150 527l-58 -140v-387h-187z",
    "L": "M105 -266v1331h187v-1145h395v-186h-582z",
    "M": "M105 -266v1331h156l152 -444l153 444h156v-1331h-187v759l-122 -353l-121 353v-759h-187z",
    "N": "M105 -266v1331h187l210 -704v704h185v-1331h-185l-210 704v-704h-187z",
    "O": "M104 -173v1145l93 93h395l95 -93v-1145l-95 -93h-395zM290 -80h210v959h-210v-959z",
    "P": "M105 -266v1331h488l94 -93v-573l-94 -93h-301v-572h-187zM292 493h208v386h-208v-386z",
    "Q": "M104 -173v1145l93 93h396l94 -93v-1145l-94 -93l56 -106h-113l-57 106h-282zM290 -80h210v959h-210v-959z",
    "R": "M105 -266v1331h488l94 -93v-573l-94 -93l94 -572h-188l-93 572h-114v-572h-187zM292 493h208v386h-208v-386z",
    "S": "M104 0h186v-80h210v386h-303l-93 93v573l93 93h395l95 -93v-173h-187v80h-210v-386h302l95 -94v-572l-95 -93h-395l-93 93v173z",
    "T": "M92 879v186h583v-186h-199v-1145h-186v1145h-198z",
    "U": "M105 -173v1238h187v-1145h210v1145h186v-1238l-93 -93h-397z",
    "V": "M89 1065h188l104 -736l102 736h189l-186 -1331h-210z",
    "W": "M99 1065h186l28 -642l119 428l118 -428l28 642h186l-57 -1331h-147l-128 466l-130 -466h-146z",
    "X": "M100 -266l198 665l-198 666h186l105 -353l106 353h186l-199 -666l199 -665h-186l-106 352l-105 -352h-186z",
    "Y": "M85 1065h193l99 -365l98 365h192l-197 -736v-595h-187v595z",
    "Z": "M105 0l395 879h-395v186h582v-266l-395 -879h395v-186h-582v266z"
};
var font_size = 24,
    tracking = 4,
    panel_Hor_Adjustment = 0,
    font_Top_Adjustment = -15,
    middleSplitAdjustment = -0.5,
    middleSpreadAdjustment = {
        left: 1,
        right: 1
    },
    small_Caps_Adjustment = {
        vertical: -170,
        horizontal: 0,
        scale_width: 0,
        scale_height: 0,
    },
    colors = {
        characters: {
            home: [
                "#FFFFFF",
            ],
            away: [
                "#00833e", // green
            ],
          	third: [
                "#44D62C", // green
            ]
        },
        numbers: {
            home: [
                "#FFFFFF",
            ],
            away: [
                "#00833e", // green
            ],
           	third: [
                "#0A0203", // Black
              	"#44D62C", // green
            ]
        }
    },
    outlines = {
        characters: {
            width: 0
        },
        numbers: {
            width: 2.5
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: -1, // this moves it up from the bottom
            horizontal: 3,
            scale_width: 12.5,
            scale_height: 12.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 10,
        left: -6.5,
        width: 115,
        height: 85,
        middle_Space: 5,
    };
